export enum BpmTaskState {
  OPEN = 'OPEN',

  FINISHED = 'FINISHED',

  ARCHIVED = 'ARCHIVED',
}
